import { useCallback, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { useDispatch } from 'react-redux'
import { isUndefined } from 'lodash/fp'

import { useQueryState } from '@monorepo/hooks'
import {
  OptionsType,
  RemoteFilterType,
  fetchOffersAction,
  // fetchSuggestionsAction,
} from '@monorepo/deprecated/core/features/SearchEngine'

export function useFetchResults() {
  const {
    state: { brandName, number },
  } = useQueryState({
    brandName: undefined,
    number: undefined,
  } as Partial<RemoteFilterType & OptionsType>)

  const crosses = true

  const dispatch = useDispatch()
  // const fetchSuggestions = useCallback(
  //   bindActionCreators(fetchSuggestionsAction, dispatch),
  //   []
  // )
  const fetchOffers = useCallback(
    bindActionCreators(fetchOffersAction, dispatch),
    []
  )

  useEffect(() => {
    if (!!number) {
      if (!brandName) {
        // fetchSuggestions(number)
      } else {
        fetchOffers({
          brandName,
          number,
          crosses: isUndefined(crosses) ? true : crosses,
        })
      }
    }
  }, [brandName, crosses, fetchOffers, number])

  return {}
}
